/* eslint-disable react/prefer-stateless-function,no-unused-vars */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import {
  changeFieldGeoTargetChangeTypeComparison,
  changeFieldGeoTargetToggleItem
} from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/actions';
import { selectFieldGeoTarget } from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/selectors';

import {
  selectIdsByGroupId,
  selectItemById,
  selectRequestsStateByGroupId,
  dataRequest
} from 'mt-react-common/common/reducers/listsCollection/reducer';

import MediumPreLoader from '../../../../../../Common/PreLoaders/MediumPreLoader';

const citiesCollectionRN = 'localeModule.collections.citiesCollection';

class CitiesLayer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (
      this.props.fieldGeoTargetRegion.typeComparison !== null &&
      !this.props.citiesIds.length > 0
    ) {
      this.props.dataRequestCities();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.fieldGeoTargetRegion.typeComparison !==
        this.props.fieldGeoTargetRegion.typeComparison &&
      !this.props.citiesIds.length > 0
    ) {
      this.props.dataRequestCities();
    }
  }

  render() {
    let citiesFragment = null;
    if (this.props.selectCitiesRequestsState.requestInProcess) {
      citiesFragment = (
        <div>
          <MediumPreLoader />
        </div>
      );
    } else if (
      this.props.fieldGeoTargetRegion.typeComparison !== null &&
      this.props.citiesIds.length > 0
    ) {
      citiesFragment = this.props.citiesIds.map(cityId => {
        const item = this.props.selectCityById(cityId);
        const isChecked = Object.keys(
          this.props.fieldGeoTargetRegion.cities
        ).includes(item.iso_code.toString());
        const isCrossedOutClass =
          (this.props.fieldGeoTargetRegion.typeComparison === '1' &&
            !isChecked) ||
          (this.props.fieldGeoTargetRegion.typeComparison === '0' && isChecked);
        return (
          <div
            key={`countryCheckbox${item.iso_code}`}
            className="checkbox abc-checkbox abc-checkbox-primary checkbox-inline"
          >
            <input
              id={`country${item.iso_code}`}
              className="styled"
              type="checkbox"
              checked={isChecked}
              value={item.iso_code}
              onChange={() =>
                this.props.changeFieldGeoTargetToggleCity(item.iso_code)
              }
            />
            <label
              htmlFor={`country${item.iso_code}`}
              className={isCrossedOutClass ? 'crossed-out' : null}
            >
              {item.name}
            </label>
          </div>
        );
      });
    }
    return (
      <React.Fragment>
        <div style={{ padding: '10px 0 10px 20px' }}>
          <div className="form-group">
            <div className="control-group" id="geoTargetRegionsTypeComparison">
              <div
                className="radio abc-radio radio-inline"
                data-target="#manual-check"
              >
                <input
                  defaultChecked={
                    this.props.fieldGeoTargetRegion.typeComparison === null
                  }
                  onChange={() => this.props.changeCitiesTypeComparison(null)}
                  id={`cities${this.props.regionIsoCode}TypeComparisonNull`}
                  name={`cities${this.props.regionIsoCode}Group`}
                  type="radio"
                />
                <label
                  htmlFor={`cities${this.props.regionIsoCode}TypeComparisonNull`}
                >
                  <div className="text-strong m-b-4">Все городские округи</div>
                </label>
              </div>
              <div
                className="radio abc-radio radio-inline"
                data-target="#auto-check"
              >
                <input
                  defaultChecked={
                    this.props.fieldGeoTargetRegion.typeComparison === '1'
                  }
                  onChange={() => this.props.changeCitiesTypeComparison('1')}
                  id={`cities${this.props.regionIsoCode}TypeComparisonAccept`}
                  name={`cities${this.props.regionIsoCode}Group`}
                  type="radio"
                />
                <label
                  htmlFor={`cities${this.props.regionIsoCode}TypeComparisonAccept`}
                >
                  <div className="text-strong m-b-4">
                    Включить городские округи
                  </div>
                </label>
              </div>
              <div
                className="radio abc-radio radio-inline"
                data-target="#auto-check"
              >
                <input
                  defaultChecked={
                    this.props.fieldGeoTargetRegion.typeComparison === '0'
                  }
                  onChange={() => this.props.changeCitiesTypeComparison('0')}
                  id={`cities${this.props.regionIsoCode}TypeComparisonExclude`}
                  name={`cities${this.props.regionIsoCode}Group`}
                  type="radio"
                />
                <label
                  htmlFor={`cities${this.props.regionIsoCode}TypeComparisonExclude`}
                >
                  <div className="text-strong m-b-4">
                    Исключить городские округи
                  </div>
                </label>
              </div>
            </div>
          </div>
          {citiesFragment}
        </div>
      </React.Fragment>
    );
  }
}

CitiesLayer.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  reducerName: PropTypes.string.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  countryIsoCode: PropTypes.string.isRequired,
  regionIsoCode: PropTypes.string.isRequired,

  fieldGeoTargetRegion: PropTypes.shape({
    typeComparison: PropTypes.any.isRequired,
    cities: PropTypes.shape.isRequired
  }).isRequired,

  changeCitiesTypeComparison: PropTypes.func.isRequired,
  changeFieldGeoTargetToggleCity: PropTypes.func.isRequired,

  citiesIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  selectCityById: PropTypes.func.isRequired,
  dataRequestCities: PropTypes.func.isRequired,

  // eslint-disable-next-line react/no-unused-prop-types
  selectCitiesRequestsState: PropTypes.shape({
    requestInProcess: PropTypes.bool.isRequired
  }).isRequired
};

const mapStateToProps = (state, props) => ({
  fieldGeoTargetRegion: selectFieldGeoTarget(state, props.reducerName).value
    .countries[props.countryIsoCode].regions[props.regionIsoCode],
  citiesIds: selectIdsByGroupId(state, citiesCollectionRN, props.regionIsoCode),
  selectCityById: id => selectItemById(state, citiesCollectionRN, id),
  selectCitiesRequestsState: selectRequestsStateByGroupId(
    state,
    citiesCollectionRN,
    props.regionIsoCode
  )
});

const mapDispatchToProps = (dispatch, props) => ({
  changeCitiesTypeComparison: value =>
    dispatch(
      changeFieldGeoTargetChangeTypeComparison(
        props.reducerName,
        props.countryIsoCode,
        props.regionIsoCode,
        value
      )
    ),
  dataRequestCities: () =>
    dispatch(
      dataRequest(citiesCollectionRN, {
        countryCode: props.countryIsoCode,
        regionCode: props.regionIsoCode
      })
    ),
  changeFieldGeoTargetToggleCity: cityIsoCode =>
    dispatch(
      changeFieldGeoTargetToggleItem(
        props.reducerName,
        props.countryIsoCode,
        props.regionIsoCode,
        cityIsoCode
      )
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CitiesLayer);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskFrom/GeoTargetTaskInputs/CountriesLayer/RegionsLayer/CitiesLayer/CitiesLayer.js